import { http, HttpResponse } from "msw"
import type { ApiFinancialDataStocks } from "../../stocks"
import { stocksMock } from "./stocks.mock"

const API_DOMAIN = import.meta.env.VITE_API_DOMAIN

export const financialDataStocksHandlers = [
  // ADH
  http.get(`${API_DOMAIN}/api/financial-data/adherent/stock`, () =>
    HttpResponse.json<ApiFinancialDataStocks>(stocksMock()),
  ),
  // ADMIN
  http.get(`${API_DOMAIN}/api/financial-data/pharmacies/:adherentId/stock`, () =>
    HttpResponse.json<ApiFinancialDataStocks>(stocksMock()),
  ),
]
